import { FC } from 'react';
import AppIntro from '../components/AppIntro';
import MainAuthPage from '../components/MainAuthPage';
import { checkIsMobile, checkIsTablet } from '@/utils/device';

const AuthIndexPage: FC = () => {
  // We must absolutely check if the device is mobile and not a tablet. In some case checkIsMobile() can return true for tablets.
  if (checkIsMobile() && !checkIsTablet()) {
    return <AppIntro />;
  }

  return <MainAuthPage />;
};

export default AuthIndexPage;
